// Generated by scripts/contract.mjs from the plugin OpenAPI schema. Do not edit.
import createClient from 'openapi-fetch';
import type { paths as auditPaths } from './audit';
import type { paths as authPaths } from './auth';
import type { paths as fleetStatePaths } from './fleetState';
import type { paths as githubPaths } from './github';
import type { paths as maintenancePaths } from './maintenance';
import type { paths as notificationsPaths } from './notifications';
import type { paths as provisioningPaths } from './provisioning';
import type { paths as serverAccessPaths } from './serverAccess';

export type * as audit from './audit';
export type * as auth from './auth';
export type * as fleetState from './fleetState';
export type * as github from './github';
export type * as maintenance from './maintenance';
export type * as notifications from './notifications';
export type * as provisioning from './provisioning';
export type * as serverAccess from './serverAccess';

/** Every call carries the portal marker header checked on writes (CSRF guard). */
const init = (base: string) => ({ baseUrl: base, credentials: 'same-origin' as const, headers: { 'X-Kanbios-Client': 'portal-web' } });

export function createApiClients(origin = '') {
  return {
    audit: createClient<auditPaths>(init(`${origin}/api/audit`)),
    auth: createClient<authPaths>(init(`${origin}/api/auth`)),
    fleetState: createClient<fleetStatePaths>(init(`${origin}/api/fleet-state`)),
    github: createClient<githubPaths>(init(`${origin}/api/github`)),
    maintenance: createClient<maintenancePaths>(init(`${origin}/api/maintenance`)),
    notifications: createClient<notificationsPaths>(init(`${origin}/api/notifications`)),
    provisioning: createClient<provisioningPaths>(init(`${origin}/api/provisioning`)),
    serverAccess: createClient<serverAccessPaths>(init(`${origin}/api/server-access`)),
  };
}

export type ApiClients = ReturnType<typeof createApiClients>;
